import * as React from "react";

const Footer = () => {
    return <footer className="footer text-center">
        <p></p>
    </footer>;
}

export default Footer;